module.exports = __webpack_public_path__ + "img/海量⼴告创意管理.e16e4802.png";